import React, { useEffect, useContext } from 'react'
import classNames from 'classnames'
import ChipDropdown from 'components/ChipDropdown'
import AskVisoActions from './AskVisoActions'
import Tag from '../../../Tag/Tag'
import AskVisoModels from './AskVisoModels'
import { CommentInput } from 'components/Comment/index'
import { modeList, modeListAppBuilding } from '../../constants'
import { SlidePanelScrollContext } from 'components/SlidePanel'
import './AskVisoPrompt.scss'

const welcomeAgent = {
  incidents: 'incident manager'
}

const AskVisoPrompt = ({
  color,
  onAskAgent,
  setModelType,
  modelType,
  isFullscreen,
  isLoading,
  setMode,
  mode,
  promptValue,
  setPromptValue,
  chatId,
  submitDisabled,
  isWelcome,
  isFooter,
  contextType,
  suggestionsList,
  modelList,
  hideModes
}) => {
  const { scrollToBottom } = useContext(SlidePanelScrollContext)
  const isSubmitDisabled = submitDisabled !== undefined ? submitDisabled : (!promptValue || isLoading)
 const modes = contextType === 'appBuilding' ? modeListAppBuilding : modeList

  useEffect(() => {
    if (isLoading) {
      scrollToBottom()
    }
  }, [isLoading])

  const onModeChange = (value) => {
    if (!isWelcome) {
      value.length > 0 && suggestionsList.length > 0 && !promptValue && setPromptValue(suggestionsList[0])
    }
    setMode(value)
  }

  return (
    <div
      className={classNames(
        'ask-viso-prompt',
        isFullscreen && 'ask-viso-prompt--fullscreen',
        isWelcome && 'ask-viso-prompt--welcome',
        isFooter && 'ask-viso-prompt--footer'
      )}
    >
      {isWelcome &&
        <div className='ask-viso-prompt__title'>
          Meet Viso AI,<br />
          your personal {welcomeAgent[contextType] || 'data scientist'}
        </div>
      }
      <div className='ask-viso-prompt__content'>
        <CommentInput placeholder='Ask Viso about your data' value={promptValue} onChange={setPromptValue} noBorder />
        <AskVisoActions
          color={color}
          onSubmit={() => {
            if (promptValue) {
              onAskAgent(promptValue, chatId, scrollToBottom)
              setPromptValue('')
            }
          }}
          submitDisabled={isWelcome ? false : isSubmitDisabled}
        >
          <AskVisoModels color={color} setModelType={setModelType} modelType={modelType} contextType={contextType} modelList={modelList} />
          {!hideModes &&
            <Tag
              autocomplete={modes}
              isDropDown
              isSingleSelect
              dropUp
              hideLabel
              placeholder='Mode'
              color={color}
              tags={mode || []}
              onChange={onModeChange}
              hasBadges
            />
          }
        </AskVisoActions>
      </div>
      {isWelcome &&
        <div className='ask-viso-prompt__suggestions'>
          {suggestionsList?.map((suggestion, index) => (
            <ChipDropdown
              key={index}
              label={suggestion}
              color='outline'
              background='body-bg'
              labelOnly
              onClick={() => setPromptValue(suggestion)}
            />
          ))}
        </div>
      }
    </div>
  )
}

export default AskVisoPrompt